"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var TableMenuIsDeprecated_1 = require("../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var TableActionMoreActions_1 = require("../../../../../../shared/components/table_actions/TableActionMoreActions");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var TableActionMail_1 = require("../../../../../../shared/components/table_actions/TableActionMail");
var ParAffilatesList = /** @class */ (function (_super) {
    __extends(ParAffilatesList, _super);
    function ParAffilatesList(props) {
        var _this = _super.call(this, props) || this;
        _this.action_edit_branding_template = "action:edit-branding-template";
        _this.action_edit_banner_template = "action:edit-banner-template";
        _this.action_access_config = "action:access-config";
        _this.columns = [
            {
                title: 'Название',
                dataIndex: _this.props.data.dk_title,
                key: _this.props.data.dk_title,
                width: 200,
            }, {
                title: 'Идентификатор',
                dataIndex: _this.props.data.dk_identity,
                key: _this.props.data.dk_identity,
                width: 150
            },
            {
                title: 'Доступен',
                dataIndex: _this.props.data.dk_admin_allowed_count,
                key: _this.props.data.dk_admin_allowed_count,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.admin_allowed_count,
                        " \u0430\u0434\u043C."));
                },
                width: 120,
            }, {
                title: 'Заблокирован',
                dataIndex: _this.props.data.dk_is_locked,
                key: _this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать бренд", text: "Да" }, unlockedTexts: { menu: "Разблокировать бренд", text: "Нет" }, record: { key: record.key, title: record.title, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 120,
            }, {
                title: 'Устаревший',
                dataIndex: _this.props.data.dk_is_deprecated,
                key: _this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { deprecatedTexts: { menu: "Пометить как устаревший", text: "Да" }, notDeprecatedTexts: { menu: "Пометить как актуальный", text: "Нет" }, record: { key: record.key, title: record.title, deprecated: record.is_deprecated }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                width: 120,
            }, {
                title: 'Описание',
                dataIndex: _this.props.data.dk_description,
                key: _this.props.data.dk_description,
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onAffilateConfigClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditGateWayClick(record); } }),
                    React.createElement(TableActionMail_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C SMTP", onClick: function () { _this.onConfigBrandSMTPClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePermissionClick(record); } }),
                    React.createElement(TableActionMoreActions_1.default, { hint: "\u0415\u0449\u0435", menu: _this.getMoreActionsDropDownMenu(record) }))); },
                width: 120
            }
        ];
        return _this;
    }
    ParAffilatesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0
        }, function () {
            _this.props.data.LoadData();
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    ParAffilatesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    ParAffilatesList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData();
            });
        }
    };
    ParAffilatesList.prototype.doDeprecateAction = function (key, title, deprecate) {
        this.props.data.SetIsDeprecated(key, deprecate, function () {
            if (deprecate) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F.\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u0430 \u043A\u0430\u043A \u0443\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0438\u0439"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F.\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u0430 \u043A\u0430\u043A \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0439"));
            }
        });
    };
    ParAffilatesList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.SetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F.\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F.\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430"));
            }
        });
    };
    ParAffilatesList.prototype.onConfigBrandSMTPClick = function (record) {
        if (this.props.onSMTPConfigClick) {
            this.props.onSMTPConfigClick(record);
        }
    };
    ParAffilatesList.prototype.doMorection = function (e, record) {
        if (e.key == this.action_edit_branding_template) {
            if (this.props.onEditBrandingTemplateClick) {
                this.props.onEditBrandingTemplateClick(record);
            }
        }
        if (e.key == this.action_edit_banner_template) {
            if (this.props.onEditBannerTemplateClick) {
                this.props.onEditBannerTemplateClick(record);
            }
        }
        if (e.key == this.action_access_config) {
            if (this.props.onAccessConfigClick) {
                this.props.onAccessConfigClick(record);
            }
        }
    };
    ParAffilatesList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doMorection(e, record); } },
            React.createElement(antd_1.Menu.Item, { key: this.action_access_config },
                React.createElement(FontAwesome_1.FA, { icon: "user-lock", left: true }),
                "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430")));
    };
    ParAffilatesList.prototype.onAffilateConfigClick = function (record) {
        if (this.props.onAffilateConfigClick) {
            this.props.onAffilateConfigClick(record);
        }
    };
    ParAffilatesList.prototype.onEditGateWayClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    ParAffilatesList.prototype.onDeletePermissionClick = function (record) {
        this.props.data.DeleteGws(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F.\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    ParAffilatesList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    ParAffilatesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData();
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    ParAffilatesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "EMail \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0434\u043B\u044F \u0441\u0432\u044F\u0437\u0438:"),
                            " [",
                            record.pprogram_contacts_email,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "Telegram \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0434\u043B\u044F \u0441\u0432\u044F\u0437\u0438:"),
                            " [",
                            record.pprogram_contacts_telegram,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "EMail \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0434\u043B\u044F \u043F\u0440\u043E\u043C\u043E:"),
                            " [",
                            record.new_promo_contacts_email,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "Telegram \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0434\u043B\u044F \u043F\u0440\u043E\u043C\u043E:"),
                            " [",
                            record.new_promo_contacts_telegram,
                            "] ")));
                }, scroll: { x: true } })));
    };
    return ParAffilatesList;
}(React.Component));
exports.default = ParAffilatesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/AffilatesList.tsx
// module id = 2010
// module chunks = 0